import { QuestionCircleOutlined } from "@ant-design/icons";
import { addCustomAppInsightsEvent } from "utils/helpers";
import styles from "./HelpCenterLink.module.scss";

interface HelpCenterLinkProps {
  clickEventId: string;
  linkName: string;
  pagePath: string;
  url: string;
  companyId: string;
}

const HelpCenterLink = (props: HelpCenterLinkProps) => {
  const model = {
    "ClickEventId": props.clickEventId,
    "LinkName": props.linkName,
    "PagePath": props.pagePath,
    "Url": props.url,
    "CompanyId": sessionStorage.getItem("ipaGroup")!,
    "User": sessionStorage.user_id
  }

  return (
    <>
      <div className={`${styles["help-center-link"]}`}>
        <QuestionCircleOutlined className="mr-1" />
        <a
          href={props.url}
          target="_blank"
          onClick={() => addCustomAppInsightsEvent(props.clickEventId, model)}
        >
          {props.linkName}
        </a>
      </div>
    </>
  );
};

export default HelpCenterLink;
